import { equalsCaseInsensitive } from 'util/strings'

export const hasTicketStateTypeCondition = (conditions, ticketStateType) => {
  return (conditions || []).some(
    c =>
      equalsCaseInsensitive(c.param, 'status') &&
      equalsCaseInsensitive(c.operator, 'eq') &&
      equalsCaseInsensitive(c.value, ticketStateType)
  )
}
